import React, {createContext, useContext, useState, useCallback} from "react";
import {isEqual, isFunction} from "lodash";
import {initialFilter} from "./OffersUIHelpers";

const OffersUIContext = createContext();

export function useOffersUIContext() {
  return useContext(OffersUIContext);
}

export const OffersUIConsumer = OffersUIContext.Consumer;

export function OffersUIProvider({offersUIEvents, children}) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback(nextQueryParams => {
    setQueryParamsBase(prevQueryParams => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const initOffer = {
    _id: undefined,
    username: "",
    referCode: "",
    offerName:"",
    device: "",
    geo: "",
    ipSignup: "",
    points: 0,
    createdAt: "",
    isActive: "",
    provision: 0,
    isVerfied: 1
  };

  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    initOffer,
    newOfferButtonClick: offersUIEvents.newOfferButtonClick,
    openEditOfferDialog: offersUIEvents.openEditOfferDialog,
    openDeleteOfferDialog: offersUIEvents.openDeleteOfferDialog,
    openDeleteOffersDialog: offersUIEvents.openDeleteOffersDialog,
    openFetchOffersDialog: offersUIEvents.openFetchOffersDialog,
    openUpdateOffersStatusDialog: offersUIEvents.openUpdateOffersStatusDialog,
    openFetchOffersDetailsDialog: offersUIEvents.openFetchOffersDetailsDialog
  };

  return <OffersUIContext.Provider value={value}>{children}</OffersUIContext.Provider>;
}